/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Readiness_UnansweredInputs */

const en_us2_workout_readiness_unanswered = /** @type {(inputs: Workout_Readiness_UnansweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No answers, the workout goes as planned`)
};

const pt_br2_workout_readiness_unanswered = /** @type {(inputs: Workout_Readiness_UnansweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem respostas, o treino segue como planejado`)
};

const es_419_workout_readiness_unanswered = /** @type {(inputs: Workout_Readiness_UnansweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin respuestas, el entrenamiento sigue según lo planeado`)
};

const pt_pt2_workout_readiness_unanswered = /** @type {(inputs: Workout_Readiness_UnansweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem respostas, o treino segue como planeado`)
};

const fr_fr2_workout_readiness_unanswered = /** @type {(inputs: Workout_Readiness_UnansweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sans réponse, la séance se déroule comme prévu`)
};

const de_de2_workout_readiness_unanswered = /** @type {(inputs: Workout_Readiness_UnansweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Antworten, das Training läuft wie geplant`)
};

const it_it2_workout_readiness_unanswered = /** @type {(inputs: Workout_Readiness_UnansweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna risposta, l'allenamento resta come previsto`)
};

/**
* | output |
* | --- |
* | "No answers, the workout goes as planned" |
*
* @param {Workout_Readiness_UnansweredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_readiness_unanswered = /** @type {((inputs?: Workout_Readiness_UnansweredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Readiness_UnansweredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_readiness_unanswered(inputs)
	if (locale === "es-419") return es_419_workout_readiness_unanswered(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_readiness_unanswered(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_readiness_unanswered(inputs)
	if (locale === "de-DE") return de_de2_workout_readiness_unanswered(inputs)
	if (locale === "it-IT") return it_it2_workout_readiness_unanswered(inputs)
	return en_us2_workout_readiness_unanswered(inputs)
});
export { workout_readiness_unanswered as "workout.readiness_unanswered" }